import script from "./ListDocs.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListDocs.vue?vue&type=script&setup=true&lang=ts"

import "./ListDocs.vue?vue&type=style&index=0&id=b0ccc096&lang=scss"

const __exports__ = script;

export default __exports__